import { createContext } from "react";

export const defaultChatState = {
  userId: undefined,
  otherUserId: undefined,
  setOtherUserId: () => {}
};

const ChatContext = createContext(defaultChatState);

export default ChatContext;
